export default __webpack_public_path__ + "static/media/aave.61fbbbc5.svg";